export default class UIError extends Error {
    constructor(message, details = null) {
        super(message);
        this.name = "UIError";
        this.details = details;
    }
}